import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '@/lib/supabase/client'

export default function AuthCallback() {
  const navigate = useNavigate()

  useEffect(() => {
    // Supabase processes the URL hash/code during client init (detectSessionInUrl: true),
    // which fires SIGNED_IN before this useEffect runs. Check the session directly first.
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        navigate('/games', { replace: true })
        return
      }

      // Session not ready yet — wait for the event
      const {
        data: { subscription },
      } = supabase.auth.onAuthStateChange((event) => {
        if (event === 'SIGNED_IN') {
          navigate('/games', { replace: true })
        }
      })

      return () => subscription.unsubscribe()
    })
  }, [navigate])

  return (
    <main className="min-h-screen bg-arcade-bg flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-arcade-neon border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-400 text-sm font-mono">Signing you in…</p>
      </div>
    </main>
  )
}
